export default __webpack_public_path__ + "static/media/lucky7.0b5daf79.jpg";